import { css } from "styled-components/macro";
import { sizes, landscapeRule } from "./breakpoints";

export default Object.keys(sizes).reduce(
    (acc: { [key: string]: any }, label: string) => {
        acc[label] = (...args: any) => css`
            @media (min-width: ${sizes[label]}px) {
                ${css(args)};
            }
        `;
        acc[`${label}Landscape`] = (...args: any) => css`
            @media (min-width: ${sizes[label]}px) and ${landscapeRule} {
                ${css(args)};
            }
        `;
        return acc;
    },
    {
        landscape: (...args: any) => css`
            @media ${landscapeRule} {
                ${css(args)};
            }
        `,
    }
);
